<template>
    <div>
        <!-- 登录框 -->
        <vs-dialog prevent-close overflow-hidden v-model="registerDialogActive">
            <template #header>
                <h4 class="ldl-not-margin">
                    Welcome to <b>Register</b>
                </h4>
            </template>

            <div class="ldl-con-form">
                <vs-input v-model="username" placeholder="username">
                    <template #icon>
                        @
                    </template>
                </vs-input>
                <vs-input type="password" v-model="password" placeholder="Password">
                    <template #icon>
                        <i class='bx bxs-lock'></i>
                    </template>
                </vs-input>
                <div class="ldl-flex">
                    <vs-checkbox v-model="disclaimers"><span @click="showDisclaimers">disclaimers</span></vs-checkbox>
                    <a href="" @click="showLoginDialog">Go back Login</a>
                </div>
            </div>

            <template #footer>
                <div class="ldl-footer-dialog">
                    <vs-button block @click="register">
                        Register
                    </vs-button>
                </div>
            </template>
        </vs-dialog>

        <Disclaimers :disclaimersDialogActive="disclaimersDialogActive"></Disclaimers>
    </div>
</template>

<script>

import Disclaimers from '@/components/Disclaimers.vue'
export default {
  name: 'Register',
  components: {
    Disclaimers
  },
  data () {
    return {
      username: '',
      password: '',

      disclaimers: false,
      disclaimersDialogActive: '',

      registerDialogActive: false
    }
  },
  methods: {
    register () {

    },
    showDisclaimers () {
      this.disclaimersDialogActive = 'yyy' + (Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000)
    },

    showLoginDialog () {
      this.registerDialogActive = false

      this.common.eventBus().$emit('openLoginDialog')
    }
  },
  created () {
    this.common.eventBus().$on('openRegisterDialog', () => {
      this.username = ''
      this.password = ''
      this.disclaimers = false

      this.registerDialogActive = true
      this.disclaimersDialogActive = ''
    })
  }
}
</script>

<style>
    .ldl-not-margin {
        margin: 0px;
        font-weight: normal;
        padding: 10px
    }

    .ldl-con-form{
        width: 100%
    }

    .ldl-flex {
        display: flex;
        align-items: center;
        justify-content: space-between
    }
    a {
        font-size: .8rem;
        margin-left: 6px;
    }
    .vs-checkbox-label {
        font-size: .8rem
    }
    .vs-input-content{
        margin: 10px 0px;
        width: calc(100%)
    }
    .vs-input {
        width: 100% !important
    }
    .ldl-footer-dialog {
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        width: calc(100%)
    }
    .ldl-new {
        margin: 0px;
        margin-top: 20px;
        padding: 0px;
        font-size: .7rem
    }
    .vs-button {
        margin: 0px
    }
  </style>
